import Instrument1 from 'images/thumbs/instruments/caixaChinesa.png';
import Instrument2 from 'images/thumbs/instruments/clavas.png';
import Instrument3 from 'images/thumbs/instruments/jogoSinos.png';
import Instrument4 from 'images/thumbs/instruments/metSoprano.png';
import Instrument5 from 'images/thumbs/instruments/pandeireta.png';
import Instrument6 from 'images/thumbs/instruments/pratos.png';
import Instrument7 from 'images/thumbs/instruments/triangulos.png';
import Instrument8 from 'images/thumbs/instruments/xilBaixo.png';
import Instrument9 from 'images/thumbs/instruments/xilSoprano.png';
import Instrument10 from 'images/thumbs/instruments/xilContralto.png';
import Instrument11 from 'images/thumbs/instruments/metBAixo.png';
import Instrument12 from 'images/thumbs/instruments/metContralto.png';
import Instrument13 from 'images/thumbs/instruments/bongos.png';
import Instrument14 from 'images/thumbs/instruments/tamborim.png';

export const INSTRUMENTS = [
    { title: 'Metalofone baixo', slug: 'metalofone-baixo', thumb: { path: Instrument11 } },
    { title: 'Xilofone baixo', slug: 'xilofone-baixo', thumb: { path: Instrument8 } },
    { title: 'Metalofone soprano', slug: 'metalofone-soprano', thumb: { path: Instrument4 } },
    { title: 'Xilofone soprano', slug: 'xilofone-soprano', thumb: { path: Instrument9 } },
    { title: 'Metalofone contralto', slug: 'metalofone-contralto', thumb: { path: Instrument12 } },
    { title: 'Xilofone contralto', slug: 'xilofone-contralto', thumb: { path: Instrument10 } },
    { title: 'Jogo de sinos', slug: 'jogo-sinos', thumb: { path: Instrument3 } },
    { title: 'Caixa chinesa', slug: 'caixa-chinesa', thumb: { path: Instrument1 } },
    { title: 'Clavas', slug: 'clavas', thumb: { path: Instrument2 } },
    { title: 'Pandeireta', slug: 'pandeireta', thumb: { path: Instrument5 } },
    { title: 'Triângulo', slug: 'triangulo', thumb: { path: Instrument7 } },
    { title: 'Pratos', slug: 'pratos', thumb: { path: Instrument6 } },
    { title: 'Bongós', slug: 'bongos', thumb: { path: Instrument13 } },
    { title: 'Tamborim', slug: 'tamborim', thumb: { path: Instrument14 } }
];